import { ref, type Ref } from 'vue'
import { useDevLogger } from '@/composables/dev-logger'
import { debounce } from '@/lib/helpers'

type WindowSize = {
  width: Ref<number>
  height: Ref<number>
}

type ResizeTarget = {
  innerWidth: number
  innerHeight: number
}

let instance: boolean | null = null

const height: Ref<number> = ref(window.innerHeight)
const width: Ref<number> = ref(window.innerWidth)

const logger = useDevLogger('resize-listener')

const onResize = debounce(({ target }: { target: ResizeTarget }) => {
  const { innerWidth, innerHeight } = target
  width.value = innerWidth
  height.value = innerHeight
}, 500)

export const createWindowResizeListener = (): boolean | string | void => {
  if (instance)
    return logger.error('There is existing instance of resize-listener')

  onResize({ target: window })
  window.addEventListener('resize', onResize)
  instance = true

  return instance
}

export const destroyWindowResizeListener = (): null => {
  window.removeEventListener('resize', onResize)
  instance = null

  return null
}

export const useWindowResizeListener = (): WindowSize => {
  return {
    width,
    height,
  }
}
